import type { ApplicationEditions } from '@jira/platform__application-editions/src/edition.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

export const useAppEditions = (): ApplicationEditions => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.appEditions;
};
